var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expired-licence-page"},[_c('ExpiredLicenceAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }